export default __webpack_public_path__ + "static/media/ford.14264e53.glb";